import { errHandler } from "utils/common";
import api from "utils/api";

export default class Laporan {
  RekapPME = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-pme`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  RekapMMP = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-mmp`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  Ketenagaan = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/ketenagaan`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  DataDasarLab = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/data-dasar-lab`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  MicroscopistFaskes = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/microscopists-faskes`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  CrossCheckKab = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/crosscheck-kab`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  CrossCheckProv = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/crosscheck-prov`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  UjiSilang = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/uji-silang`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  UjiSilangVerifikasi = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/uji-silang-verifikasi`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  UjiSilangRekap = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/uji-silang-rekap`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  ZeroReport = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/zero-report`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  Regmal1 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal1`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  Regmal1Excel = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal1/excel`, {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  Regmal1Csv = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal1/csv`, {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  RekapRegmal2 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-regmal2`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  RekapRegmalRujukan = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rujukan`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  Regmal2 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal2`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  Regmal2BKK = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal2-bkk`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  MalariaKIA = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/malaria-kia`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  TarikData1 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/tarik-data1`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  TarikData1Public = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/tarik-data1-public`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  TarikData1Private = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/tarik-data1-private`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  LogistikED = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/logistic-ed`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  KasusPE = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/pe`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  // regmal 2 public
  Regmal2Public = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal2-public`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  // regmal 2 private
  Regmal2Private = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal2-private`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  LogistikStokOut = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/logistic-stock-out`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  LogistikStok = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/logistic-stock`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  DataReseptifitas = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/reseptifitas`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  LogistikStokUse = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/logistic-use`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  IdentifikasiJentik = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/vektor-jentik`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  IdentifikasiNyamuk = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/vektor-nyamuk`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  KelengkapanPerBulan = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/completness-report`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  PengendalianVektor = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/pengendalian-vektor`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapPengendalianVektor = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-pengendalian-vektor`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  DataDanMonitoringKader = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/cadre`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  CadreRekapActive = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/cadre-rekap-active`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  CadreRekapActiveByLast3MonthPerform = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/cadre-rekap-active-by-last-3-month`, {
          params: params,
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  LaporanKinerjaKader = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/cadre-performance`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  LaporanRekapKeaktifanKader = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/cadre-rekap-active`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  LaporanKinerjaKaderMMP = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/cadre-performance-mmp`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  MMPDanMonitoringKaderMMP = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/cadre-mmp`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  DataDasarPenduduk = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/population`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  ValidasiKasusIndigenous = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/validasi-indigenous`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  UjiSilangIndividu = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/uji-silang-individu`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapKelambu = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-kelambu`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapIRS = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-irs`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  Rekap1PemantauanJentik = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap1-pemantauan-jentik`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  Rekap2PemantauanJentik = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap2-pemantauan-jentik`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  Tren2PemantauanJentik = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/tren2-pemantauan-jentik`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapKohortLengkap = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-kohort-lengkap`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapMaster = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-master`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapIndividuKnowlesiLab34 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-individu-knowlesi-lab34`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  Regmal1DomicileVillage = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal1-domicile-village`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  Regmal1DomicileVillageExcel = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/regmal1-domicile-village/excel`, {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapAgregatKnowlesiLab34 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-agregat-knowlesi-lab34`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapIndividuKnowlesiFasyankes = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-individu-knowlesi-fasyankes`, {
          params: params,
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapAgregatKnowlesiFasyankes = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-agregat-knowlesi-fasyankes`, {
          params: params,
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapIndividuKnowlesiLab5 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-individu-knowlesi-lab5`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  RekapAgregatKnowlesiLab5 = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/laporan/rekap-agregat-knowlesi-lab5`, { params: params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
